import { render, staticRenderFns } from "./phoneRegister.vue?vue&type=template&id=18a7f1d2&scoped=true"
import script from "./phoneRegister.vue?vue&type=script&lang=js"
export * from "./phoneRegister.vue?vue&type=script&lang=js"
import style0 from "./phoneRegister.vue?vue&type=style&index=0&id=18a7f1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7f1d2",
  null
  
)

export default component.exports